module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAAORJREFUKFOdkgFtAkEURN8ooA4KCqgEHLQ4AAXFAUUBoKAnARS0DgAFrYSiYJs5/pLNwhHCJpfc3u3bmT//i2KllJ6Ad+ANeIlfe2ADrCX95ePKLymlCbAEDF9bhqaSfAktGNBnB1B/HhtW2Pu5oVSDVh4Y/ADmd6rlYwuDLn54A5xGOD73nAMzmCpoG/vXCKOJcnZA/5xqDUrKgY0kfQf0VbSnZa9ZbSTZntN2ay4g4NAVTgP4WdVKYbUNx7f+Ar07kz261scHoBo5W+tSttJMkks4jVwB27YHYlT09hB9XJVD/g/yll+06dDnfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/auditPass.png
// module id = 78Jm
// module chunks = 1